import { loadGraphQLData } from '../page';
import CLPContainer from './category-landing-page-container';

export default {
    component: CLPContainer,
    loadData: loadGraphQLData,
};
